export const RIGHTS_TERMS_VERSION = '2026-05-26';

export const rightsTermsContent = {
  fo: {
    title: 'Treytir fyri rættindahavarar',
    subtitle: 'Terms for rights holders',
    updatedLabel: 'Útgáva',
    intro:
      'Hesar treytir eru galdandi fyri ein og hvønn (persón ella felag), sum leggur tilfar út á Stroyma (hereftir "Pallurin").',
    sections: [
      {
        title: '1. Ábyrgd og trygging móti endurgjaldið',
        paragraphs: [
          'Rættindahavarin (tú) hevur eina og alla ábyrgd av tilfarinum, ið verður lagt út. Filmshúsið er einans ein tøkniligur pallur (Host) og tekur ikki ábyrgd fyri innihaldinum.',
          'Tú (Rættindahavarin) váttar, at Filmshúsið er undantikið einum og hvørjum kravi, útreiðslu ella tapi, sum stendst av:',
        ],
        bullets: [
          'At títt tilfar brýtur upphavsrætt, patent ella annan rætt hjá triðja parti.',
          'Einari og hvørji trætu viðvíkjandi eigaraskapi ella rættindum til filmin.',
        ],
      },
      {
        title: '2. Rættindi, tú letur pallinum',
        paragraphs: [
          'Við at leggja títt tilfar út, gevur tú pallinum eitt ikki-einkarætt (non-exclusive) loyvi at:',
        ],
        bullets: [
          'Goyma (hosta) tínar fílar.',
          'Vísa (stroyma) filmin til brúkarar, ið gjalda fyri atgongd (Transactional Video on Demand, TVOD).',
          'Brúka brot, myndir (stills) og undansýning (trailer) úr filminum til marknaðarføring av filminum og pallinum.',
        ],
        closing: 'Tú varðveitir øll onnur rættindi til títt verk.',
      },
      {
        title: '3. Takedown-politikkur (Taka niður tilfar)',
        paragraphs: [
          'Hetta er okkara neyðbremsa. Um Filmshúsið fær eina áheitan ella klagu frá triðja parti um, at títt tilfar møguliga brýtur teirra rættindi, eitt nú ein tónleikari, sum ikki hevur fingið samsýning, tilskilar Filmshúsið sær rættin at:',
        ],
        bullets: [
          'Beinanvegin taka tilfarið niður av pallinum uttan ávaring, meðan málið verður kannað.',
          'Krevja fulla skjalprógvan frá tær fyri, at rættindini eru í lagi.',
        ],
        closing:
          'Filmshúsið hevur ikki ábyrgd fyri nøkrum tapi, tú hevur í hesum sambandi.',
      },
      {
        title: '4. Varnarting',
        paragraphs: [
          'Hesar treytir eru undirlagdar føroyskari lóg. Ein og hvør ósemja viðvíkjandi tænastuni ella hesum treytum, sum partarnir ikki kunnu semjast um, skal avgerðast eftir føroyskari lóggeving.',
        ],
      },
    ],
  },
  en: {
    title: 'Terms for Rights Holders',
    subtitle: 'Treytir fyri rættindahavarar',
    updatedLabel: 'Version',
    intro:
      'These terms apply to every person or company that uploads content to Stroyma (the "Platform").',
    sections: [
      {
        title: '1. Responsibility and indemnity',
        paragraphs: [
          'The rights holder (you) has full responsibility for the content that is uploaded. Filmshúsið is only a technical platform (host) and does not accept responsibility for the content.',
          'You (the rights holder) confirm that Filmshúsið is held harmless from any claim, cost, or loss arising from:',
        ],
        bullets: [
          'Your content infringing copyright, patent, or another third-party right.',
          'Any dispute concerning ownership of, or rights to, the film.',
        ],
      },
      {
        title: '2. Rights you grant the Platform',
        paragraphs: [
          'By uploading your content, you grant the Platform a non-exclusive licence to:',
        ],
        bullets: [
          'Store (host) your files.',
          'Show (stream) the film to users who pay for access (Transactional Video on Demand, TVOD).',
          'Use clips, still images, and trailers from the film to market the film and the Platform.',
        ],
        closing: 'You retain all other rights to your work.',
      },
      {
        title: '3. Takedown policy',
        paragraphs: [
          'This is our emergency brake. If Filmshúsið receives a request or complaint from a third party that your content may infringe their rights, for example a musician who has not been paid, Filmshúsið reserves the right to:',
        ],
        bullets: [
          'Immediately remove the content from the Platform without warning while the matter is investigated.',
          'Require full documentation from you showing that the rights are in order.',
        ],
        closing:
          'Filmshúsið is not responsible for any loss you may have in this connection.',
      },
      {
        title: '4. Jurisdiction',
        paragraphs: [
          'These terms are governed by Faroese law. Any disagreement concerning the service or these terms that the parties cannot resolve shall be decided under Faroese law.',
        ],
      },
    ],
  },
};
